import { InjectionToken } from '@angular/core';
import { NgxsConfig } from '@ngxs/store/src/symbols';
import { TABTestConfig } from '@x/common/ab-test/ab-test.config';
import { BarcodeModuleConfig } from '@x/common/barcode/barcode.config';
import { IBrowserModuleConfig } from '@x/common/browser/browser.config';
import { CloudinaryModuleConfig } from '@x/common/cloudinary';
import { IconModuleConfig } from '@x/common/icon/icon.config';
import { MapConfig } from '@x/common/map/map';
import { MetaModuleConfig } from '@x/common/meta';
import { MoneyModuleConfig } from '@x/common/money/money.config';
import { IReferralModuleConfig } from '@x/common/referral/referral.config';
import { StorageModuleConfig } from '@x/common/storage';
import { ITrackingConfig } from '@x/common/tracking';
import { ContentClientModuleConfig } from '@x/content/client';
import { ContentRenderBrandConfig } from '@x/content/render';
import { IChannelSelectOption } from '@x/ecommerce-shop/app/channel/state';
import { TAvailabilityStatusConfig } from '@x/ecommerce-shop/app/core/availability/availability.service';
import { EcommerceBackendUrlModuleConfig } from '@x/ecommerce/backend-url';
import { EcommerceShopClientModuleConfig } from '@x/ecommerce/shop-client';
import { GeocodeClientModuleConfig, ICountryItem } from '@x/geocode/client';

export interface IShopConfig {
  flavor: 'bt' | 'tn';
  brand: ContentRenderBrandConfig;
  production: boolean;
  meta: MetaModuleConfig;
  cloudinary: CloudinaryModuleConfig;
  ngxs: Partial<NgxsConfig>;
  defaultCountry: ICountryItem;
  ecommerceBackend: EcommerceBackendUrlModuleConfig;
  ecommerceShopClient: EcommerceShopClientModuleConfig;
  contentClient: ContentClientModuleConfig;
  geocodeClient: GeocodeClientModuleConfig;
  money: MoneyModuleConfig;
  date: {
    format?: string;
  };
  barcode: BarcodeModuleConfig;
  defaultLocale: 'en-ZA' | 'en-GB' | 'en-US' | 'af-ZA';
  storageConfig: StorageModuleConfig;
  iconConfig: IconModuleConfig;
  abTestConfig?: TABTestConfig;
  contactInfo: {
    email: string;
    phone: string;
    whatsapp?: {
      number: string;
      link: string;
    };
    availability: string;
  };
  googleMaps: MapConfig;
  features: {
    taxonChips?: boolean;
    productListingViewMoreMode: 'simple' | 'detailed';
    productViewMobileStickyActionBar: boolean;
    deliveryFeeMsg?: string;
    deliverySlotCalendar?: boolean;
    enableNeedHelpChat: boolean;
    newsletterOptIn?: {
      onRegistration: boolean;
      enabledByDefault: boolean;
      text: string;
      policy?: {
        absoluteUrl: string;
        textToMatch: string;
      };
    };
    showRegionOverlayTaxons?: string[];
    mainMenu: {
      taxonTargetLevel: number[];
    };
    menuTree: {
      taxonTargetLevel: number[];
      nodeAutoClose?: boolean;
    };
    availability: {
      showUnavailableSlots: boolean;
      showDeliveryRegionBadges: boolean;
      availabilityStatus: TAvailabilityStatusConfig;
      useDefaultRegionFromChannel?: boolean;
    };
    addressing?: {
      instructionsMaxLength?: number;
    };
    nextDayDelivery?: {
      nextDayFee: string;
      standardFee: string;
      freeThreshold: string;
    };
    deliveryIndicator?: boolean;
  };
  externalShopLink?: IChannelSelectOption;
  referral?: IReferralModuleConfig;
  tracking?: ITrackingConfig;
  browser: IBrowserModuleConfig;
}

export const SHOP_CONFIG = new InjectionToken<IShopConfig>('SHOP_CONFIG');
